module.exports = "../dist/frontend/icons/ui/no.svg?0176b7e09998a67910b51d88c24fdb1c";